import { StackNavigationProp, createStackNavigator } from "@react-navigation/stack";
import React from "react";

import ChangePassword from "@/screens/ChangePassword";
import DeactivateAccount from "@/screens/DeactivateAccount";
import HelpCentral from "@/screens/HelpCentral";
import NotificationList from "@/screens/NotificationList";
import Profile from "@/screens/Profile";
import Settings from "@/screens/Settings";

export type SettingsStackParamList = {
  settings: undefined;
  helpCentral: undefined;
  notifications: undefined;
  profile: undefined;
  changePassword: undefined;
  deactivateAccount: undefined;
};

export const SettingsRoutePaths = {
  settings: "ajustes",
  helpCentral: "central-de-ajuda",
  notifications: "notificacoes",
  profile: "perfil",
  changePassword: "alterar-senha",
  deactivateAccount: "desativar-conta",
};

export type SettingsNavigation = StackNavigationProp<SettingsStackParamList>;

const SettingsStackNav = createStackNavigator<SettingsStackParamList>();

export const SettingsStack = () => {
  return (
    <SettingsStackNav.Navigator
      initialRouteName="settings"
      screenOptions={{ headerShown: false, headerMode: "screen" }}>
      <SettingsStackNav.Screen
        name="settings"
        component={Settings}
        options={{ title: "Ajustes" }}
      />
      <SettingsStackNav.Screen
        name="helpCentral"
        component={HelpCentral}
        options={{ title: "Central de Ajuda" }}
      />
      <SettingsStackNav.Screen
        name="notifications"
        component={NotificationList}
        options={{ title: "Notificações" }}
      />
      <SettingsStackNav.Screen name="profile" component={Profile} options={{ title: "Perfil" }} />
      <SettingsStackNav.Screen
        name="changePassword"
        component={ChangePassword}
        options={{ title: "Alterar Senha" }}
      />
      <SettingsStackNav.Screen
        name="deactivateAccount"
        component={DeactivateAccount}
        options={{ title: "Desativar Conta" }}
      />
    </SettingsStackNav.Navigator>
  );
};
